import {
  has, flow, every, nthArg,
  isArray, mapKeys, mapValues,
  upperCase, isPlainObject
} from 'lodash-es'

import {
  toObject,
  isPosInteger,
  toPosInteger,
  toGtZeroInteger,
  isGtZeroInteger
} from '../utils/bits'

import StrictObj from '../utils/strict-obj'

export function toCustomPlan(v) {
  const plan = toObject(v)
  if (isArray(plan)) {
    for (let index = 0, length = plan.length; index !== length; index++) {
      const option = plan[index]
      if (has(option, 'from')) option.from = toPosInteger(option.from)
      if (has(option, 'rows')) option.rows = toGtZeroInteger(option.rows)
      if (has(option, 'cols')) option.cols = toGtZeroInteger(option.cols)
      if (has(option, 'rowHeight')) option.rowHeight = toGtZeroInteger(option.rowHeight)
      plan[index] = StrictObj(option)
    }
    return plan
  } else if (isPlainObject(plan)) {
    const fixedKeys = mapKeys(plan, flow(nthArg(1), upperCase))
    const fixedValues = mapValues(fixedKeys, toGtZeroInteger)
    return StrictObj(fixedValues)
  } else {
    return null
  }
}

export function isCustomPlan(v) {
  if (isArray(v)) {
    return true
      && isArray(v)
      && v.length !== 0
      && v.every((option) => true
          && (!has(option, 'from') || isPosInteger(option.from))
          && (!has(option, 'rows') || isGtZeroInteger(option.rows))
          && (!has(option, 'rowHeight') || isGtZeroInteger(option.rowHeight)))
  } else if (isPlainObject(v)) {
    return every(v, isGtZeroInteger)
  } else {
    return false
  }
}
